import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import TodaysWorkoutCard from './TodaysWorkoutCard';
import UpcomingClassesCard from './UpcomingClassesCard';
import CurrentStreakCard from './CurrentStreakCard';
import PersonalRecordsCard from './PersonalRecordsCard';
import GoalProgressCard from './GoalProgressCard';
import AICoachCard from './AICoachCard';
import MonthlyChallengeCard from './MonthlyChallengeCard';
import TrainingLoadCard from './TrainingLoadCard';
import AchievementsCard from './AchievementsCard';
import LeaderboardCard from './LeaderboardCard';
import FitnessScoreCard from './FitnessScoreCard';
import AttendanceHeatmapCard from './AttendanceHeatmapCard';
import MonthlyRevenueCard from './admin/MonthlyRevenueCard';
import CustomerActivityCard from './admin/CustomerActivityCard';
import UpcomingBirthdaysCard from './admin/UpcomingBirthdaysCard';
import DirectoryService from '../directory/DirectoryService';
import {
  todaysWorkout,
  attendanceData,
  personalRecords,
  goals,
  aiCoachSummary,
  monthlyChallenge,
  trainingLoad,
  achievements,
  leaderboard,
  fitnessScore
} from 'data/dashboard/crossfit';
import {
  customerActivity,
  upcomingBirthdays,
  monthlyRevenue
} from 'data/dashboard/wodAdmin';
import ProgrammingService from './programming/ProgrammingService';
import PaymentService from './payments/PaymentService';
import TourService from '../common/TourService';
import AnnoucementWidget from '../annoucements/AnnoucementWidget';

const WodLandingPage = () => {
  const [workout, setWorkout] = useState();
  const [monthlyRevenueData, setMonthlyRevenueData] = useState();
  const isWodAdmin = DirectoryService.isLoggedByWODAdmin();

  useEffect(() => {

    ProgrammingService.retrieveTodaysWOD().then(workout => {
      console.log('TodaysWOD', workout);
      setWorkout(workout);
    }).catch(error => {
      console.error('Error retrieving today\'s WOD:', error);
    });
  }, []);
  useEffect(() => {
    if (isWodAdmin) {
      PaymentService.retrieveMonthlyRevenueData().then(data => {
        const updatedData = data.predicted !== 0 ? data : monthlyRevenue;
        setMonthlyRevenueData(updatedData);
      });
    }
    const showGuide = localStorage.getItem('bstShowGuide');
    if (showGuide === 'true') {
      const tour = TourService.retrieveMainWODTour();
      tour.start();
    }
  }, [isWodAdmin]);

  // Fetch data for the dashboard here if needed
  return (
    <>
      <AnnoucementWidget className="mb-3" />
      {/* WOD-Admin Only - Business Overview */}
      {isWodAdmin && (
        <Row className="g-3 mb-3">
          <Col lg={4}>
            {monthlyRevenueData && <MonthlyRevenueCard data={monthlyRevenueData} />}
          </Col>

          <Col lg={4}>
            <CustomerActivityCard mockData={customerActivity} />
          </Col>
          <Col lg={4}>
            <UpcomingBirthdaysCard />
          </Col>
        </Row>
      )}

      {/* Hero Section - Today's Workout */}
      <Row className="g-3 mb-3">
        {workout && (<Col lg={8}>
          <TodaysWorkoutCard workout={workout} />
        </Col>)}
        <Col lg={4} id="current-streak">
          <CurrentStreakCard data={attendanceData} />
        </Col>
      </Row>

      {/* Upcoming Classes and AI Coach */}
      <Row className="g-3 mb-3">
        <Col lg={6} xl={4} id="upcoming-classes">
          <UpcomingClassesCard />
        </Col>
        <Col lg={6} xl={4} id="ai-coach">
          <AICoachCard />
        </Col>
        <Col lg={12} xl={4}>
          <MonthlyChallengeCard challenge={monthlyChallenge} />
        </Col>
      </Row>

      {/* Performance Overview */}
      <Row className="g-3 mb-3">
        <Col lg={6} id="personal-records">
          <PersonalRecordsCard records={personalRecords} />
        </Col>
        <Col lg={6}>
          <GoalProgressCard goals={goals} />
        </Col>
      </Row>

      {/* Training Analytics */}
      <Row className="g-3 mb-3">
        <Col lg={12}>
          <AttendanceHeatmapCard data={attendanceData} />
        </Col>
      </Row>

      {/* Recovery and Training Load */}
      <Row className="g-3 mb-3">
        <Col lg={12} xl={8}>
          <AchievementsCard achievements={achievements} />
        </Col>
        <Col lg={12} xl={4} id="leaderboard">
          <LeaderboardCard leaderboard={leaderboard} />
        </Col>
      </Row>
    </>
  );
};

export default WodLandingPage;
